import * as Sentry from '@sentry/browser';

import {
  EncryptorPreprocessorParameters,
  PreprocessorConfiguration,
  PreprocessorTypes,
} from '@cashier/cashier-model';

const appendEncrypter = (id: string, src: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const encrypterScript = document.getElementById(id);

    if (!encrypterScript && src) {
      const script = document.createElement('script');
      script.id = id;
      script.type = 'text/javascript';
      script.async = true;
      script.src = src;

      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${id}`));

      document.body.appendChild(script);
    } else if (encrypterScript) {
      resolve();
    } else {
      reject(new Error(`Failed to load script: ${id}`));
    }
  });
};

const getEncryptorV1Url = (
  parameters: EncryptorPreprocessorParameters,
): string => {
  if (parameters?.preprocessorUrl) {
    return parameters?.preprocessorUrl;
  }

  // BC for internal PIQ integration
  if (parameters?.paymentIqMerchantId) {
    return `${(window as any).paymentIqCardEncrypterUrl}/${parameters.paymentIqMerchantId}`;
  }

  Sentry.captureException(
    new Error(
      '####Encryptor url not found: paymentIqMerchantId is missing####',
    ),
    { extra: { parameters } },
  );

  return '';
};

export const loadPreprocessorResources = (
  preprocessor: PreprocessorConfiguration,
): Promise<void> => {
  switch (preprocessor.type) {
    case PreprocessorTypes.ENCRYPTOR_V2:
      return appendEncrypter(
        'encryptorV2Script',
        preprocessor.parameters.preprocessorUrl,
      );
    case PreprocessorTypes.ENCRYPTOR_V1:
      return appendEncrypter(
        'encryptorV1Script',
        getEncryptorV1Url(
          preprocessor.parameters as EncryptorPreprocessorParameters,
        ),
      );
    default:
      return Promise.resolve();
  }
};
